module.exports = __webpack_public_path__ + "img/map-arrow.c5ca6d65.svg";